import { TableType } from '@/coreDomainsModule/table';
import { KeyType, TableContentHeader } from './tableContentHeaders';
import { TableContentItem } from './tableContentItems';
import { LoadingState } from '@/coreDomainsModule/uiLoadingState';

/**
 * 絞り込み用の状態
 */
export interface NarrowState {
  narrowKey: string[];
  narrowValue: number | string;
  narrowType: KeyType;
}

/**
 * 列幅変更用の状態
 */
export interface ResizeState {
  resizingIndex: number;
  currentMousePageX: number;
}

/**
 * 編集可能セル
 */
export type EditableCell =
  | 'OrderNumber'
  | 'OrderEstimateTimeOfArrival'
  | 'OrderAmount'
  | 'OrderRecommendStatus'
  | 'OrderDeleteButton'
  | 'OrderMemo';

/**
 * 編集可能セルかどうか
 * @param key - キー
 */
export const isEditableCell = (key: string): key is EditableCell => {
  return [
    'OrderNumber',
    'OrderEstimateTimeOfArrival',
    'OrderAmount',
    'OrderRecommendStatus',
    'OrderEditButton',
    'OrderDeleteButton',
    'OrderMemo',
  ].includes(key);
};

/**
 * 編集可能セルの変更
 */
export interface ChangeEditableCell {
  oldValue: string;
  newValue: string;
  newRawValue: string | number | Date;
}

/**
 * 編集可能セルの変更履歴
 */
export interface ChangeEditableCellHistory {
  [id: string]: {
    [key in EditableCell]: {
      changeValue?: ChangeEditableCell;
    };
  };
}

/**
 * uiState
 * tableContentProperties: テーブルのヘッダーの定義
 * tableType: テーブルの種類
 * accumulationTableContentWidth: テーブルの幅の累積和（ヘッダー固定のため）
 * items: テーブルのデータ
 * isLoading: ローディング状態
 * loadingState: ローディング状態
 * isEditing: 編集中かどうか
 * isAllSelected: 全選択状態
 * selectedIds: 選択されたID
 * narrowStates: 絞り込み用の状態
 * resizeState: 列幅変更用の状態
 * changeEditableCellHistory: 編集可能セルの変更履歴(これ自体は、外部のコンポーネントで保存等の処理を行う想定)
 */
export interface IBaseTableContentState {
  tableContentProperties: TableContentHeader;
  tableType: TableType;
  accumulationTableContentWidth: number[];
  items: TableContentItem[];
  loadingState: LoadingState;
  isEditing: boolean;
  isAllSelected: boolean;
  selectedIds: string[];
  narrowStates: NarrowState[];
  resizeState: ResizeState;
  changeEditableCellHistory: ChangeEditableCellHistory;
  isOpeningAlertIndex: string;
  isOpenHeaderModifyButtonMenu: boolean;
}
